import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { O5ClusterUpsertDrawer } from '../../../../../../../features/o5/cluster/o5-cluster-upsert-drawer';
import { O5ClustersTable } from '../../../../../../../features/o5/cluster/o5-clusters-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/cluster/_cluster/')({
  head: () => getPageHead('Clusters'),
  component: O5ClusterList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <O5ClusterUpsertDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Upsert Cluster" size="small" />} />
        </RequiresAccess>
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function O5ClusterList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5ClustersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
